{ DndProvider } = ReactDnD
IconButton = require 'components/common/icon_button'
{
  MULTIPLE_INPUT_ITEM_DND_TYPE
  dragSpec
  dropSpec
  dragCollect
  dropCollect
} = require './multiple_input_item_dnd_spec'

MultipleInputItem = createReactClass
  displayName: 'MultipleInputItem'

  itemRef: (el) ->
    @item = el

  render: ->
    {
      connectDragSource
      connectDropTarget
      item
      items
      index
      isDragging
      isOver
      onApply
      onDelete
      onMove
      readOnly
      renderItem
    } = @props

    className = classNames 'multiple-inputs__input', {
      dragging: isDragging
      over: isOver
    }

    connectDragSource(
      connectDropTarget(
        <div className={className} ref={@itemRef}>
          {!readOnly and <div className="drag-marker" />}
          <div className="multiple-inputs__content">
            {renderItem({
              item
              items
              index
              onApply
              onDelete
              onMove
              readOnly
            })}
            {!readOnly and
              <div>
                <IconButton
                  className="ml-10"
                  iconName="cross"
                  onClick={onDelete}
                />
              </div>}
          </div>
        </div>
      )
    )

DragSourcedMultipleInputItem = ReactDnD.DragSource(
  MULTIPLE_INPUT_ITEM_DND_TYPE, dragSpec, dragCollect
) MultipleInputItem
DraggableMultipleInputItem = ReactDnD.DropTarget(
  MULTIPLE_INPUT_ITEM_DND_TYPE, dropSpec, dropCollect
) DragSourcedMultipleInputItem

MultipleInputs = createReactClass
  displayName: 'MultipleInputs'

  propTypes:
    value: PropTypes.array
    onApply: PropTypes.func.isRequired
    addValueLabel: PropTypes.string
    getNewItem: PropTypes.func
    placeholder: PropTypes.string
    readOnly: PropTypes.bool
    initialValue: PropTypes.array
    renderAddControl: PropTypes.func
    renderItem: PropTypes.func

  getDefaultProps: ->
    addValueLabel: ''
    getNewItem: -> ''
    placeholder: ''
    readOnly: false
    initialValue: []
    renderAddControl: null
    renderItem: ({ item, onApply, placeholder, readOnly }) ->
      <div className="input__textarea">
        not implemented
      </div>

  getValuesFromProps: (props) ->
    { initialValue, value } = props

    if _.isEmpty(value)
      return initialValue.slice()

    value.slice()

  getCurrentValues: ->
    @getValuesFromProps(@props)

  resetItemIds: (values) ->
    @itemIds = _.map values, -> _.uniqueId('multiple-input-')

  ensureItemIds: (values) ->
    @itemIds ?= []

    while @itemIds.length < values.length
      @itemIds.push _.uniqueId('multiple-input-')

    if @itemIds.length > values.length
      @itemIds = @itemIds.slice(0, values.length)

  componentWillReceiveProps: (nextProps) ->
    currentValues = @getCurrentValues()
    nextValues = @getValuesFromProps(nextProps)

    if @pendingValues? and _.isEqual(nextValues, @pendingValues)
      @pendingValues = null
      return

    @pendingValues = null
    return if _.isEqual(nextValues, currentValues)

    # External resyncs do not preserve row identity, so force remounts.
    @resetItemIds(nextValues)

  applyValues: (values) ->
    @pendingValues = values
    @props.onApply(values)

  onAddValue: ->
    { getNewItem, readOnly } = @props
    return if readOnly
    values = @getCurrentValues()
    @itemIds ?= []
    @itemIds.push _.uniqueId('multiple-input-')
    @applyValues values.concat getNewItem()

  onApply: (idx) -> (newValue) =>
    { readOnly } = @props
    return if readOnly
    values = @getCurrentValues()
    values[idx] = newValue
    @applyValues values

  onDeleteValue: (idx) -> =>
    { readOnly } = @props
    return if readOnly
    values = @getCurrentValues()
    values.splice idx, 1
    @itemIds.splice idx, 1 if @itemIds?
    @applyValues values

  onMoveValue: (dragIndex, hoverIndex) ->
    { readOnly } = @props
    return if readOnly
    values = @getCurrentValues()
    movedValue = values[dragIndex]
    return unless movedValue?

    values.splice dragIndex, 1
    values.splice hoverIndex, 0, movedValue

    if @itemIds?
      movedItemId = @itemIds[dragIndex]
      @itemIds.splice dragIndex, 1
      @itemIds.splice hoverIndex, 0, movedItemId

    @applyValues values

  render: ->
    {
      addValueLabel
      placeholder
      readOnly
      renderAddControl
      renderItem
      value
      initialValue
    } = @props

    values = if _.isEmpty(value)
      unless _.isEmpty(initialValue)
        initialValue
    else
      value

    values = values ? []
    @ensureItemIds values

    <DndProvider backend={ReactDnDHTML5Backend.default}>
      <div className="multiple-inputs">
        {_.map values, (content, idx) =>
          renderRow = (itemProps) ->
            renderItem _.extend {}, itemProps, { placeholder }

          <DraggableMultipleInputItem
            index={idx}
            item={content}
            itemId={@itemIds[idx]}
            items={values}
            key={@itemIds[idx]}
            onApply={@onApply(idx)}
            onDelete={@onDeleteValue(idx)}
            onMove={@onMoveValue}
            readOnly={readOnly}
            renderItem={renderRow}
          />
        }
        {!readOnly and
          <div className="multiple-inputs__add">
            {if renderAddControl
              renderAddControl(onAdd: @onAddValue)
            else
              <span className="add-link" onClick={@onAddValue}>
                + {addValueLabel}
              </span>
            }
          </div>
        }
      </div>
    </DndProvider>

module.exports = MultipleInputs
